__turbopack_context__.v({
  "className": "oswald_1a80239b-module__h5kUVa__className",
  "variable": "oswald_1a80239b-module__h5kUVa__variable",
});
